import { action, makeObservable, observable, runInAction } from 'mobx';
import { BaseAddEditViewModel } from '../../../../core/services/BaseViewModel';
import { OraModel } from './OraModel';
import { Appl } from '../../../../core/Appl';
import { ISraService, SraService } from '../SraService';
import { Service } from 'typedi';

@Service() // eslint-disable-next-line
export default class OraViewModel extends BaseAddEditViewModel {

    private service: ISraService;
    @observable public model: OraModel = {
        guId: '',
        firstName: '',
        lastName: '',
        middleInitial: '',
        email: '',
    };

    constructor() {
        super('SCERS Member Portal');
        this.service = Appl.Services.get<ISraService>('ISraService');
        makeObservable(this);
    }

    @action
    public async getFormattedUrlAsync(): Promise<string> {
        let url = '';
        Appl.Validator.init();
        await Appl.Validator.validateString('Member GUID', 'guId', this.model.guId, true, 40);
        // await Appl.Validator.validateString('First Name', 'firstName', this.model.firstName, true, 100);
        // await Appl.Validator.validateString('Last Name', 'lastName', this.model.lastName, true, 100);
        // await Appl.Validator.validateEmail('Email Address', 'email', this.model.email, true, 100);
        if (Appl.Validator.isValid()) {
            const result = await this.service.getUrl(this.model);
            if (result.success) {
                url = result.data;
                window.open(`${url}`)
                return url;
            } else {
                Appl.Error.handle(result.error);
            }
        }
        return '';
    }

}
